module.exports = __webpack_public_path__ + "img/BankID_logo_black.0553ead2.png";